import './headingArt.css';

const assets = {
  goal: 'goal', silver: 'metals', gold: 'metals', bar: 'metals',
  wallet: 'wallet', delivery: 'delivery', history: 'clock', clock: 'clock',
  family: 'family', person: 'family', receipt: 'receipt',
  info: 'info', support: 'info', shield: 'shield',
};

export default function HeadingArt({name = 'goal', size = 56, className = '', eager = false}) {
  const asset = assets[name] || 'goal';
  const base = `/qolak/heading-icons/v1/${asset}`;
  return <img className={`qc-title-art ${className}`} src={`${base}-128.webp`}
    srcSet={`${base}-64.webp 64w, ${base}-128.webp 128w, ${base}-256.webp 256w`}
    sizes={`${size}px`} width={size} height={size} style={{'--title-art-size': `${size}px`}}
    alt="" aria-hidden="true" draggable="false" decoding="async" loading={eager ? 'eager' : 'lazy'}/>;
}
